import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WhatsAppOutlinedSvg from "@ant-design/icons-svg/es/asn/WhatsAppOutlined";
import AntdIcon from "../components/AntdIcon";
var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WhatsAppOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WhatsAppOutlined.displayName = 'WhatsAppOutlined';
}
export default /*#__PURE__*/React.forwardRef(WhatsAppOutlined);